import { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';

import { AiOutlineClose } from 'react-icons/ai';

export default function ProductTableDetails({
  productName,
  productDetails,
  setIsOpen,
  isOpen,
}) {
  return (
    <Transition show={isOpen} as={Fragment}>
      <Dialog
        // open={isOpen}
        onClose={() => setIsOpen(false)}
        className="relative z-50"
      >
        <div className="fixed inset-0 bg-black/75" aria-hidden="true" />

        <div className="fixed inset-0 flex items-center justify-center p-4 ">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Dialog.Panel className=" min-w-min max-w-[90%] px-8 md:px-10 py-6 mx-auto bg-white rounded max-h-[90%] overflow-y-auto">
              <div className="flex flex-col items-center justify-between gap-4 pb-4">
                <di className="flex items-center justify-between w-full">
                  <p className="text-2xl font-bold">{productName}</p>
                  <button
                    className="flex items-center justify-center p-2 text-gray-500 border rounded-lg"
                    onClick={() => setIsOpen(false)}
                  >
                    <AiOutlineClose />
                  </button>
                </di>

                <table className="">
                  {/* Mobile */}
                  <tbody className="md:hidden">
                    {productDetails
                      ? productDetails.map((line, value) => (
                          <>
                            <tr key={value} className="border-2">
                              <td
                                className="w-30 px-2.5 py-1.5 border-2 bg-gray-100"
                                colSpan={Object.values(line) === '' ? 2 : 1}
                              >
                                <p className="font-medium">
                                  {Object.keys(line)}
                                </p>
                              </td>
                            </tr>

                            {Object.values(line) !== '' ? (
                              <tr key={`${value}_bis`} className="border-2">
                                <td className="px-2.5 py-1.5">
                                  {Object.values(line)}
                                </td>
                              </tr>
                            ) : null}
                          </>
                        ))
                      : 'Nessun dato'}
                  </tbody>
                  {/* Desktop */}
                  <tbody className="hidden min-w-content md:block">
                    {productDetails
                      ? productDetails.map((line, value) => (
                          <>
                            <tr key={value} className="border-2">
                              <td
                                className="px-2.5 py-1.5 border-2 bg-gray-100"
                                colSpan={Object.values(line) === '' ? 2 : 1}
                              >
                                <p className="font-medium">
                                  {Object.keys(line)}
                                </p>
                              </td>

                              {Object.values(line) !== '' ? (
                                <td className="px-2.5 py-1.5">
                                  {Object.values(line)}
                                </td>
                              ) : null}
                            </tr>
                          </>
                        ))
                      : 'Nessun dato'}
                  </tbody>
                </table>
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
}
